<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Permits</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link href="./assets/libs/owl.carousel/assets/owl.carousel.min.css" rel="stylesheet">
    <link href="./assets/libs/owl.carousel/assets/owl.theme.default.min.css" rel="stylesheet">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Business Permits - Declined Applications</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a></li>
                    <li class="breadcrumb-item active">Declined Applications</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <ToolBar/>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3" role="toolbar">
                    <label class="text-nowrap mb-0 px-2">Date From:</label>
                    <input v-model="dateFrom" class="form-control pr-3" type="date">
                    <label class="text-nowrap mb-0 px-2">Date To:</label>
                    <input v-model="dateTo" class="form-control pr-2" type="date">
                    <label class="text-nowrap mb-0 px-2">Business Activity:</label>
                    <select @change="getTradeSubCategory($event)" class="form-control bg-white" data-live-search="true" title="Select Business Activity">
                      <option value=" ">All</option>
                      <option :key="index" :value="item.incomeTypeId" v-for="(item, index) in tradeCategories">
                        {{ item.incomeTypeDescription }}
                      </option>
                    </select>
                    <label class="text-nowrap mb-0 mx-2">Business Sub Category:</label>
                    <select @change="selectedTradeSubCategory($event)" class="form-control bg-white" data-live-search="true" title="Select Sub Categories">
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in tradeSubCategories">
                        {{ item.feeDescription }}
                      </option>
                    </select>
                    <select @change="selectedSubCounty($event)" class="form-control bg-white" data-live-search="true" title="Select Sub County" style="margin-left: 10px">
                      <option value="">All Sub Counties</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                        {{ item.subCountyName }}
                      </option>
                    </select>
                    <select @change="selectedWard($event)" class="form-control bg-white" data-live-search="true" title="Select Ward" style="margin-left: 10px">
                      <option value="">All Wards</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                        {{ item.wardName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom d-flex">
                  <div class="d-flex align-items-center justify-content-center p-3 flex-grow-1" role="toolbar">
                    <form class="app-search p-0 m-0 w-100">
                      <div class="position-relative">
                        <input v-model="search" type="text" class="form-control w-100" placeholder="Search... eg Business Name, ID Number, Bill Number, etc">
                        <span class="bx bx-search-alt"></span>
                      </div>
                    </form>
                  </div>
                  <div class="pr-3">
                    <button v-if="getRight('SBP DOWNLOAD DECLINED')" @click="downloadApplicationsPaginated()" class="btn btn-primary" :disabled="isDownloading">
                      <i class="bx bx-download me-2"></i>
                      {{ isDownloading ? 'Downloading...' : 'Download' }}
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">Receipt No.</th>
                        <th scope="col">Business ID</th>
                        <th scope="col">Business Name</th>
                        <th scope="col">Application Date</th>
                        <th>Licensing Officer</th>
                        <th>Status</th>
                        <th class="text-right" scope="col">Amount Paid</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" v-for="(item, index) in businesses">
                        <td class="text-capitalize text-nowrap">{{item.billNo}}</td>
                        <td class="text-capitalize text-nowrap">{{item.businessID}}</td>
                        <td class="text-capitalize text-nowrap">
                          <a href="javascript: void(0);">{{item.businessName}}</a>
                        </td>
                        <td class="text-capitalize text-nowrap">{{formattedDate(item.startDate)}}</td>
                        <td>{{item.issuingOfficer}}</td>
                        <td>
                          <span class="badge badge-soft-danger text-uppercase">{{item.stageStatus}}</span>
                        </td>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(item.receiptAmount)}}</span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end">
                            <button @click="getBusinessDetails(item.businessID,item.billNo)" class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-3" data-bs-target=".receipting-modal" data-bs-toggle="modal" type="button">
                              <i class="bx bx-show font-size-16 align-middle me-2"></i>
                              Application Details
                            </button>
                            <a @click="printBill(item.billNo)" class="btn btn-success btn-sm waves-effect waves-light" href="javascript: void(0);">
                              <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                              Print Receipt
                            </a>
                            <div class="dropdown">
                              <a aria-haspopup="true" class="text-muted font-size-16" data-bs-toggle="dropdown" role="button">
                                <i class="bx bx-dots-vertical-rounded"></i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a @click="getBusinessDetails(item.businessID,item.billNo)" class="dropdown-item" data-bs-target=".receipting-modal" data-bs-toggle="modal" href="javascript: void(0);">
                                  <i class="font-size-15 mdi mdi-eye me-3"></i>View
                                </a>
                                <a @click="printBill(item.billNo)" class="dropdown-item" href="javascript: void(0);">
                                  <i class="font-size-15 mdi mdi-printer me-3"></i>Print
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th>{{businesses.length}} Certs</th>
                        <th class="text-nowrap" colspan="4"></th>
                        <td class="text-nowrap text-right" colspan="2">
                          <span class="fw-semibold">KES {{numberFormat(totalAmount)}}</span>
                        </td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center d-flex justify-content-center" v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. Please wait...</p>
                      </div>
                    </div>

                    <div class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center" v-if="businesses.length<1 && loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results" class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria.</p>
                    </div>
                  </div>
                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="pr-3 pb-0 mb-0 font-13px">Rows Per Page</span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                      </select>
                    </div>
                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a @click="prevPage" class="page-link">Previous</a>
                      </li>
                      <li :class="{ active: currentPage === page }" :key="page" class="page-item" v-for="page in pagination(currentPage, totalPages, 3)">
                        <span class="page-link" v-if="page === '...'">{{ page }}</span>
                        <a @click="goToPage(page)" class="page-link" v-else>{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a @click="nextPage" class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-full modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Business Details</h5>
              <span class="badge rounded-pill bg-warning text-uppercase font-12px mx-3">{{entries.stageStatus}}</span>
              <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
            </div>
            <div class="modal-body">
              <div v-if="loadingDetails" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-3">Loading business details...</p>
              </div>

              <div v-else class="row">
                <div class="col-12">
                  <div class="hori-timeline mt-4">
                    <div class="owl-carousel owl-theme navs-carousel events timeline-carousel" id="timeline-carousel">
                      <div :class="item.completed==='active' ? 'active' : ''" class="item event-list" v-for="(item, index) in statuses" :key="index" style="display: inline-block; width: 350px">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">{{getHumanDate(item.updatedDate)}}</div>
                            <h5 class="mb-4">{{item.status}}</h5>
                          </div>
                          <div class="event-down-icon">
                            <i v-if="item.completed==='true'" class="bx bxs-check-circle h1 text-success down-arrow-icon"></i>
                            <i v-if="item.completed==='false' || item.completed==='active'" class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>
                          <div class="mt-3 px-3">
                            <p class="text-muted text-capitalize"><a href="javascript: void(0);">{{item.issuingOfficer}}</a></p>
                            <p v-if="item.statusID !== '2'" class="text-muted text-capitalize mb-1">
                              <i class="bx bx-map"></i>{{item.location}}
                            </p>
                            <p v-if="item.completed === 'true' && item.statusID==='2'" @click="printReceipt()" class="text-muted text-capitalize mb-1">
                              <a href="javascript: void(0);"><i class="bx bx-receipt"></i> View Receipt</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-info border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bx-briefcase-alt-2 font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Business Details</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">
                            Verification Status<br>
                            <a href="javascript: void(0);">({{entries.issuingOfficer}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Name</p></td>
                            <td>{{businessDetails.businessName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Plot Number</p></td>
                            <td>{{businessDetails.plotNumber}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">KRA Pin No.</p></td>
                            <td>{{businessDetails.kraPin}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">VAT No.</p></td>
                            <td>{{businessDetails.kraPin}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Activity</p></td>
                            <td>{{businessDetails.businessDes}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr v-if="businessDetails.feeID === billDetail.feeID">
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p></td>
                            <td>{{billDetail.feeDescription}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr class="text-danger fw-semibold" v-if="businessDetails.feeID !== billDetail.feeID">
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p></td>
                            <td>{{billDetail.feeDescription}}</td>
                            <td class="text-right"><i class="bx bx-x text-danger font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-12" v-if="businessDetails.feeID !== billDetail.feeID">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th colspan="3">
                            Corrections Needed/Done<br>
                            <a href="javascript: void(0);">({{entries.issuingOfficer}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr class="fw-semibold text-capitalize">
                            <td class="text-primary">
                              <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p>
                            </td>
                            <td>
                              <span class="text-primary">change to:</span>
                              {{businessDetails.businessSubCategory}}
                            </td>
                            <td class="text-right"><i class="bx bx-x text-danger font-28"></i></td>
                          </tr>
                          <tr class="fw-semibold text-capitalize">
                            <td class="text-primary">
                              <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Additional Amount</p>
                            </td>
                            <td>
                              <span class="text-primary">KES {{feesAndCharges.unitFeeAmount - billDetail.receiptAmount}}</span>
                              (BILL NO. {{billDetail.billNo}})
                            </td>
                            <td class="text-right"><i class="bx bx-x text-danger font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bxs-user-pin font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Owner Details</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">
                            Verification Status<br>
                            <a href="javascript: void(0);">({{businessDetails.createdBy}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Full Names</p></td>
                            <td>{{businessDetails.fullNames}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">ID/PPT No.</p></td>
                            <td>{{businessDetails.ownerID}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Email</p></td>
                            <td>{{businessDetails.ownerEmail}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Mobile No.</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.ownerPhone">
                                {{maskPhoneNumber(businessDetails.ownerPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Alternative Mobile No.</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.ownerPhone">
                                {{maskPhoneNumber(businessDetails.ownerPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Postal Address</p></td>
                            <td>{{businessDetails.postalAddress}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bx-phone-call font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Location and Contact Information</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">
                            Verification Status<br>
                            <a href="javascript: void(0);">({{entries.issuingOfficer}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Mobile No.</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.businessPhone">
                                {{maskPhoneNumber(businessDetails.businessPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Alternative Phone No</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.businessPhone">
                                {{maskPhoneNumber(businessDetails.businessPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Email address</p></td>
                            <td>
                              <a :href="'mailto:' + businessDetails.businessEmail">
                                {{businessDetails.businessEmail}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Sub county</p></td>
                            <td>{{businessDetails.subCountyName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Ward</p></td>
                            <td>{{businessDetails.wardName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Physical address/Street</p></td>
                            <td>{{businessDetails.physicalAddress}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Building Name</p></td>
                            <td>{{businessDetails.buildingName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Stall/Room No.</p></td>
                            <td>{{businessDetails.roomNo}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-8">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-dark border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bx-map font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Map View</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <iframe frameborder="0" scrolling="no" style="width: 100%; height: 450px;" :src="iframeSrc"></iframe>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bxs-edit-alt font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Revenue Officer Notes ({{entries.issuingOfficer}})</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="alert alert-warning border-1 border-warning" role="alert">
                        {{entries.comments || 'No comments available'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a @click="printReceipt()" class="btn btn-primary waves-effect waves-light" type="button">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Receipt
              </a>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Government</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import router from "@/router";
import {authUrl, biller, execute, executeDownload, getRight, trade} from "@/api";
import moment from 'moment';

export default {
  name: "Declined",
  components: {ToolBar, NavigationBar},
  data() {
    return {
      search: '',
      loading: false,
      loadingDetails: false,
      isDownloading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      totalAmount: 0,
      dateFrom: '',
      dateTo: '',
      message: '',
      billNo: '',
      businesses: [],
      businessDetails: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyName: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        roomNo: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        businessPhone: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        lat: 0.0,
        lng: 0.0
      },
      billDetail: {
        billNo: null,
        feeID: null,
        feeDescription: null,
        detailAmount: null,
        receiptAmount: null,
        billBalance: null
      },
      entries: {
        issuingOfficer: null,
        stageStatus: null,
        comments: null
      },
      feesAndCharges: {
        unitFeeAmount: null
      },
      receiptDetails: {
        receiptNo: null
      },
      receiptInfos: [],
      tradeCategories: [],
      tradeSubCategories: [],
      subCounties: [],
      wards: [],
      statuses: []
    };
  },

  computed: {
    iframeSrc() {
      return 'https://maps.google.com/maps?q=' + this.businessDetails.lat + ',' + this.businessDetails.lng + '&t=&z=13&ie=UTF8&iwloc=&output=embed';
    }
  },

  mounted() {
    this.dateFrom = '';
    this.dateTo = '';
    this.getApplicationsPaginated("");
    this.getTradeCategory();
    this.getSubCounties();
    this.menuAccess();
  },

  watch: {
    pageSize() {
      this.currentPage = 1;
      this.getApplicationsPaginated("");
    },
    search() {
      this.getApplicationsPaginated(this.search);
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    }
  },

  methods: {
    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Declined Biz");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(e => console.error(e));
    },

    getRight(type) {
      return getRight(type);
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");
      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplicationsPaginated("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplicationsPaginated("");
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getApplicationsPaginated("");
      }
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    timelineCarousel() {
      if (window.$ && window.$.fn.owlCarousel) {
        $("#timeline-carousel").owlCarousel({
          items: 1,
          loop: false,
          margin: 0,
          nav: true,
          navText: ["<i class='mdi mdi-chevron-left'></i>", "<i class='mdi mdi-chevron-right'></i>"],
          dots: false,
          responsive: { 576: { items: 2 }, 768: { items: 4 } },
          startPosition: -1
        });
      }
    },

    getHumanDate(dateData) {
      if (!dateData || dateData === "-") return "-";
      try {
        const dateObject = new Date(Date.parse(dateData));
        return dateObject.toDateString();
      } catch (error) {
        return "-";
      }
    },

    async getApplicationsPaginated(search) {
      this.loading = true;
      this.businesses = [];
      try {
        const data = new FormData();
        data.append("function", "getApplicationsPaginated");
        data.append("stageStatus", "Declined");
        data.append("search", search);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const res = await execute(data, trade);
        if (res.data.success) {
          this.totalItems = res.data.data.totalItems.count;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.businesses = res.data.data.businesses;
          this.totalAmount = this.businesses.reduce((acc, cur) => {
            let totalAmount = Number(cur.receiptAmount);
            return !isNaN(totalAmount) ? acc + totalAmount : acc;
          }, 0);
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      } finally {
        this.loading = false;
      }
    },

    async downloadApplicationsPaginated() {
      this.isDownloading = true;
      try {
        const data = new FormData();
        data.append("function", "downloadApplicationsPaginated");
        data.append("statusID", "declined");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const response = await executeDownload(data, trade);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `${this.dateFrom || 'All'}_to_${this.dateTo || 'All'}_Declined_Businesses.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        this.isDownloading = false;
      }
    },

    async getBusinessDetails(businessID, billNo) {
      if (this.loadingDetails) {
        console.log('Already loading details');
        return;
      }

      this.loadingDetails = true;
      this.billNo = billNo;
      this.statuses = [];

      try {
        const data = new FormData();
        data.append("function", "getBusinessDetails");
        data.append("billNo", billNo);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, trade);
        if (res.data.success) {
          this.statuses = res.data.data.statuses;
          this.businessDetails = res.data.data.business;
          this.billDetail = res.data.data.bill.billDetails;
          this.feesAndCharges = res.data.data.feesAndCharge;
          this.receiptDetails = res.data.data.receipt.receiptDetails;
          this.receiptInfos = res.data.data.receipt.receiptInfos;
          this.entries = res.data.data.entries;

          this.$nextTick(() => {
            this.timelineCarousel();
          });
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      } finally {
        this.loadingDetails = false;
      }
    },

    formattedDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')';
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({ receiptNo: this.receiptDetails.receiptNo });
        const routeData = this.$router.resolve({ name: 'receipt' });
        window.open(routeData.href, '_blank');
      }
    },

    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller).then(res => {
        if (res.data.success) {
          this.tradeCategories = res.data.data.incomeTypes;
        }
      }).catch(e => console.error(e));
    },

    getTradeSubCategory(event) {
      this.getApplicationsPaginated(event.target.value);
      this.tradeSubCategories = [];
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller).then(res => {
        if (res.data.success) {
          this.tradeSubCategories = res.data.data.feesAndCharges;
        }
      }).catch(e => console.error(e));
    },

    selectedTradeSubCategory(event) {
      const data = JSON.parse(event.target.value);
      this.getApplicationsPaginated(data.feeId);
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data, authUrl).then(res => {
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties;
        }
      }).catch(e => console.error(e));
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, authUrl).then(res => {
        if (res.data.success) {
          this.wards = res.data.data.wards;
        }
      }).catch(e => console.error(e));
    },

    selectedSubCounty(event) {
      if (event.target.value) {
        const data = JSON.parse(event.target.value);
        this.getWards(data.subCountyID);
        this.getApplicationsPaginated(data.subCountyName);
      }
    },

    selectedWard(event) {
      if (event.target.value) {
        const data = JSON.parse(event.target.value);
        this.getApplicationsPaginated(data.wardName);
      }
    }
  }
};
</script>

<style scoped>
.spinner-border-sm { width: 1rem; height: 1rem; border-width: 0.2em; }
.btn:disabled { opacity: 0.65; cursor: not-allowed; }
</style>